export type ImageSize = 'ORIGINAL' | 'DESKTOP' | 'TABLET' | 'MOBILE';

export interface Image {
    size: ImageSize;
    url: string;
}

export interface ImpressionsList {
    title: string;
    intro?: string;
    items: ImpressionsItem[];
}

export interface ImpressionsItem {
    title: string;
    text: string;
    img: string;
    images?: Image[];
}

export interface Slide {
    number: number;
    total: number;
    title: string;
    description: string;
    image: string;
}

export enum LocaleCode {
    DE_CH = 'de-CH',
    FR_CH = 'fr-CH',
}
